export class Role {
  public id = '';
  public name = '';
  public description = '';
}
